import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { toast } from "react-toastify";

const UpdateStatusModel = ({
  updateStatusLoading,
  postUpdateStatus,
  setOpenUpdateStatusModel,
  selectedItem,
  userType,
  paymentData
}) => {
  const InitialValues = {
    id: selectedItem?.id,
    status: selectedItem?.status,
    //status: 0,
    consent: "",
    remarks: "",
  };

  console.log(selectedItem);
  console.log(paymentData);

  const SubmitHandler = (values) => {
    console.log(values.consent)
    if (values.consent == 0 && values.status == 0) {
      return toast.error("Please give Consent");
    }
    if (values.remarks.length == 0) {
      return toast.error("Please enter your remarks");
    }
    postUpdateStatus(values);
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenUpdateStatusModel}>
      <Title>{(userType==3 || userType==4) && ("Consent")} {userType==1 && "Update Status"}</Title>
      { paymentData &&
      <>
      <Divide />
      <SingleItem name={"Payment For"} value={paymentData.description} />
      <SingleItem name={"Control No"} value={paymentData.controlNumber} />
      <SingleItem name={"Amount"} value={paymentData.amount} />
      <SingleItem name={"Trans Id"} value={paymentData.trxId} />
      <SingleItem name={"Date"} value={paymentData.date} />
       {/* <SubTitle>Payment TZS {paymentData.amount} has been made against Control Number {paymentData.controlNumber}. </SubTitle> */}
      </>
      }
      {updateStatusLoading && <Loading />}

      {!updateStatusLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
            {(userType!=1) && (<InputGroup>
                <Label htmlFor="consent">Consent</Label>
                <FieldWrapper $select={true}>
                  <Field required name="consent" id="consent" autoComplete="off">
                    {(props) => (
                      <Select
                        required
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="1">Approve</MenuItem>
                        <MenuItem value="2">Reject</MenuItem>

                        {/* {(userType==1) && (
                        <><MenuItem value="1">Pending Docs</MenuItem>
                        <MenuItem value="2">Pending Payments</MenuItem>
                        <MenuItem value="3">InProgress</MenuItem>
                        <MenuItem value="4">Approved By Asst Registrar</MenuItem>
                        <MenuItem value="5">Completed</MenuItem>
                        <MenuItem value="6">Certificate Issued</MenuItem>
                        <MenuItem value="10">Rejected</MenuItem>
                        </>
                        )}

                        {(userType==3) && (
                        <><MenuItem value="1">Pending Docs</MenuItem>
                        <MenuItem value="2">Pending Payments</MenuItem>
                        <MenuItem value="5">Completed</MenuItem>
                        <MenuItem value="10">Rejected</MenuItem>
                        </>
                        )}

                        {(userType==4) && (
                        <><MenuItem value="1">Pending Docs</MenuItem>
                        <MenuItem value="2">Pending Payments</MenuItem>
                        <MenuItem value="4">Approved By Asst Registrar</MenuItem>
                        <MenuItem value="10">Rejected</MenuItem>
                        </>
                        )} */}
                        </Select>
                    )}
                  </Field>
                </FieldWrapper>
            </InputGroup>)}

            {(userType==1) && (<InputGroup>
                <Label htmlFor="status">Status</Label>
                <FieldWrapper $select={true}>
                  <Field required name="status" id="status" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="1">Pending Docs</MenuItem>
                        <MenuItem value="2">Pending Payments</MenuItem>
                        <MenuItem value="3">InProgress</MenuItem>
                        <MenuItem value="4">Approved By Asst Registrar</MenuItem>
                        <MenuItem value="5">Completed</MenuItem>
                        <MenuItem value="6">Certificate Issued</MenuItem>
                        <MenuItem value="10">Rejected</MenuItem>

                        </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>)}
              <InputGroup>
                <Label htmlFor="remarks">Remarks</Label>
                <FieldWrapper>
                  <Field
                     name="remarks"
                     type="textarea"
                     id="remarks"
                     autoComplete="off"
                     component="textarea" 
                     rows="2"
                     required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Submit</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;
const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    
    <Value>{value}</Value>
  </div>
);
const Divide = tw.p`mt-3`;

const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const SubTitle = tw.h3`text-base text-center text-gray-500 mt-4 pl-2 pr-2`;

const BtnWrapper = tw.div`flex justify-center items-center`;

export default UpdateStatusModel;
